import React from "react";

const AutomagicRegularIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 9.33992L10.6601 10M5.00828 16.7687L12.4755 9.30144C13.2993 8.47764 12.9814 7.63546 12.673 7.32703C12.3645 7.01861 11.5223 6.7007 10.6985 7.52448L3.23132 14.9917C2.92289 15.3001 2.92289 15.8002 3.23132 16.1086L3.89139 16.7687C4.19981 17.0771 4.69986 17.0771 5.00828 16.7687Z",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6 4C6 4.50982 5.50982 5 5 5C5.50982 5 6 5.49018 6 6C6 5.49018 6.49018 5 7 5C6.49018 5 6 4.50982 6 4Z",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 13C16 13 16 11 16 11C16 11 16 13 18 13C16 13 16 15 16 15C16 15 16 13 14 13Z",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 3H12.01",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(AutomagicRegularIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;